var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriggerTrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28986 13.4542C2.76645 8.55661 6.16852 4.14846 8.26963 2.13536C8.68265 1.73963 9.3173 1.73963 9.73032 2.13536C11.8314 4.14846 15.2335 8.55661 16.7101 13.4542C16.8655 13.9694 16.636 14.5181 16.1441 14.737C14.732 15.3657 12.1579 16.1614 8.99997 16.1614C5.84208 16.1614 3.26801 15.3657 1.8558 14.737C1.36397 14.5181 1.1345 13.9694 1.28986 13.4542Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.93915V10.0445",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.141V12.8817",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggerTrace);
export default __webpack_public_path__ + "static/media/triggerTrace.3b3a112d3d54e503c21785e379e674f8.svg";
export { ForwardRef as ReactComponent };